import { get, post, put, URLs } from './request';

export const getCoupon = async (code) => {
  const { data } = await get({
    url: `${URLs.tako}/restaurant/v1/new_customer_coupons/${code}`,
  });
  return data;
};

export const putCoupon = async (code) => {
  return await put({
    url: `${URLs.tako}/restaurant/v1/new_customer_coupons/${code}/redeem`,
  });
};

export const getReward = async ({ orderNumber, referrerId }) => {
  return await get({
    url: `/reward/api/diner/v1/transactions/${orderNumber}?referrer_id=${referrerId}`,
  });
};

// TODO: Not sure why referrerId is unused - figure out if it's needed or not
// eslint-disable-next-line no-unused-vars
export const postRedeemReward = async ({ orderNumber, referrerId, phoneNumber, restaurantIds }) => {
  return await post({
    url: `/reward/api/diner/v1/transactions`,
    data: {
      transaction: {
        order_number: orderNumber,
        recipient_phone_number: phoneNumber,
        restaurant_ids: restaurantIds,
      },
    },
  });
};
